import {ChartData, ChartOptions} from 'chart.js'
import {getBaseChartOptions, CHART_COLORS} from '../common'
import {EnhancementViewLevel} from '../../ReportViewLevelSelector'

const COLORS = {
  onCallHours: CHART_COLORS.primary,
  callOutRatio: CHART_COLORS.secondary
} as const

const formatHoursToTimeString = (decimalHours: number): string => {
  const hours = Math.floor(decimalHours)
  const minutes = Math.round((decimalHours - hours) * 60)
  return `${hours}h ${minutes}m`
}

export const getChartOptions = (viewLevel: EnhancementViewLevel = EnhancementViewLevel.DEPARTMENT): ChartOptions => {
  const getXAxisTitle = () => {
    switch (viewLevel) {
      case EnhancementViewLevel.TEAM:
        return 'Teams'
      case EnhancementViewLevel.EMPLOYEE:
        return 'Employees (Top 20)'
      case EnhancementViewLevel.DEPARTMENT:
      default:
        return 'Departments'
    }
  }

  return {
    ...getBaseChartOptions(),
    scales: {
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        title: {
          display: true,
          text: 'Approved On Call Hours',
          font: {
            weight: 'bold' as const
          }
        },
        grace: '10%'
      },
      y1: {
        type: 'linear' as const,
        display: true,
        position: 'right' as const,
        grid: {
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: 'Call Out to On Call Ratio',
          font: {
            weight: 'bold' as const
          }
        },
        grace: '10%'
      },
      x: {
        title: {
          display: true,
          text: getXAxisTitle(),
          font: {
            weight: 'bold' as const
          }
        }
      }
    },
    plugins: {
      ...getBaseChartOptions().plugins,
      tooltip: {
        callbacks: {
          label(context) {
            const label = context.dataset.label || ''
            const value = context.parsed.y

            if (context.dataset.yAxisID === 'y1') {
              return `${label}: ${value.toFixed(2)}`
            }

            return `${label}: ${formatHoursToTimeString(value)}`
          }
        }
      }
    },
  }
}

export const getChartDataConfig = (
  departments: string[],
  approvedOnCallHours: number[],
  callOutToOnCallRatios: number[]
): ChartData<'bar' | 'line'> => ({
  labels: departments,
  datasets: [
    {
      type: 'bar' as const,
      label: 'Approved On Call Hours',
      data: approvedOnCallHours,
      backgroundColor: COLORS.onCallHours.background,
      borderColor: COLORS.onCallHours.border,
      borderWidth: 1,
      yAxisID: 'y',
    },
    {
      type: 'line' as const,
      label: 'Call Out to On Call Ratio',
      data: callOutToOnCallRatios,
      borderColor: COLORS.callOutRatio.border,
      backgroundColor: COLORS.callOutRatio.background,
      borderWidth: 2,
      yAxisID: 'y1',
      tension: 0.1,
    },
  ],
})